import { GroupStatus } from '../../enums/group'
import { UserSearchOrderDirections, UserSearchOrderOptions } from '../../enums/user'
import { GroupDataFromSearchResult } from '../../interfaces/group.interface'
import requestBack from '../config/request-back'
import { requireInformedRequesterId } from '../utils/requester'

const createGroup = async (groupData: {
	name: string,
	users: string[],
	company_id: string,
	responsible_users?: string[],
	informedRequesterId?: string,
}) => {
	const informedRequesterId = requireInformedRequesterId(groupData?.informedRequesterId)
	const { informedRequesterId: _ignoredRequesterId, ...payload } = groupData

	let response = await requestBack({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/new-group`,
		data: {
			...payload,
			informedRequesterId,
		},
		vtAuth: true
	});

	return response;
}

/**
 * @deprecated Esta função está depreciada. Utilize `addMembers()`
 */
const addMember = async (authData: any) => {
	let response = await requestBack({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/add-member`,
		data: authData,
		vtAuth: true,
	})

	return response
}

/**
 * @deprecated Esta função está depreciada. Utilize `removeMembers()`
 */
const removeMember = async (authData: any) => {
	let response = await requestBack({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/remove-member`,
		data: authData,
		vtAuth: true,
	})

	return response
}


const getGroupById = async (groupId: any) => {
	let response = await requestBack({
		method: 'GET',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/group-by-id/${groupId}`,
		vtAuth: true,
	});

	return response;
}

/**
 * @deprecated Utilize a função `searchGroups()`
 */
const getGroupByCompany = async (filter:any,page:number,) => {
	let query = "?page=" + page 
    if (filter.company_id) {
        query += "&company_id=" + filter.company_id
    }
	let response = await requestBack({
		method: 'GET',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/groups-by-company/`+ query,
		vtAuth: true,
	})

	return response
}

/**
 * @deprecated Utilize a função `searchGroups()`
 */
const findGroup = async (filter:any,page:number,) => {
	let query = "?page=" + page 
    if (filter.company_id) {
        query += "&company_id=" + filter.company_id
    }
	if (filter.search) {
        query += "&search=" + filter.search
    }
	let response = await requestBack({
		method: 'GET',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/search-groups-by-company/`+ query,
		vtAuth: true,
	})

	return response
}

const searchGroups = async (searchParameters: {
	company_id: string,
	term?: string,
	membersStatuses?: number[],
	groupsStatuses?: number[],
	groupsSizes?: number[][],
	orderBy?: UserSearchOrderOptions,
	direction?: UserSearchOrderDirections,
	detailedMembersData?: boolean,
	responsible_users?: string[],
}): Promise<{
	 data: GroupDataFromSearchResult[],
	 total_items: number 
	}> => {
	let response = await requestBack({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/search-groups`,
		data: {...searchParameters},
		vtAuth: true,
	})

	return response;
}

const addMembers = async (groupId: string, usersIdListToAdd: string[], informedRequesterId?: string) => {
	const requesterId = requireInformedRequesterId(informedRequesterId)

	let response = await requestBack({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/add-group-members`,
		data: { id: groupId, users: usersIdListToAdd, informedRequesterId: requesterId },
		vtAuth: true,
	});

	return response;
}

const removeMembers = async (groupId: string, usersIdListToRemove: string[], informedRequesterId?: string) => {
	const requesterId = requireInformedRequesterId(informedRequesterId)

	let response = await requestBack({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/remove-group-members`,
		data: { id: groupId, users: usersIdListToRemove, informedRequesterId: requesterId },
		vtAuth: true,
	});

	return response;
}

const patchGroup = async (groupData: {
	id: string,
	name?: string,
	users?: string[],
	status?: GroupStatus,
	responsible_users?: string[],
	informedRequesterId?: string,
}) => {
	const informedRequesterId = requireInformedRequesterId(groupData?.informedRequesterId)
	const data: Record<string, unknown> = {
		id: groupData.id,
		informedRequesterId,
	}

	if (groupData.name !== undefined) {
		data.name = groupData.name
	}

	if (groupData.users !== undefined) {
		data.users = groupData.users
	}

	if (groupData.status !== undefined) {
		data.status = groupData.status
	}

	if (groupData.responsible_users !== undefined) {
		data.responsible_users = groupData.responsible_users
	}

	let response = await requestBack({
		method: 'PATCH',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/patch-group`,
		data,
		vtAuth: true,
	});

	return response;
}


export { getGroupById as getGroupId, removeMember, addMember, createGroup, getGroupByCompany, findGroup, searchGroups, addMembers, removeMembers, patchGroup }
